<template>
  <nav class="tabs">
    <button
      v-for="tab in tabPresenters"
      :key="tab.title"
      :class="tab.classList"
      class="tab"
      @click="handleClickTab(tab.index)"
    >
      <h3 class="title">{{ tab.title }}</h3>
      <p v-if="tab.count" class="count">{{ tab.count }} รายการ</p>
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    currentIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    tabPresenters() {
      return this.tabs.map(({ title, count }, index) => ({
        index,
        title,
        count: count ? count.toLocaleString() : undefined,
        classList: {
          active: this.currentIndex === index
        }
      }));
    }
  },
  methods: {
    handleClickTab(index) {
      this.$emit("change-tab", index);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  flex-flow: row nowrap;

  border-bottom: 1px solid #e0e0e0;
  padding: 0 15px;

  background-color: #f9f9f9;
}

.tab {
  position: relative;
  display: block;

  margin-bottom: -1px;
  border: 0;
  border-radius: 0;
  padding: 15px;
  min-width: 110px;

  background: transparent;

  &:focus {
    outline: 0;
  }

  &::after {
    content: "";

    position: absolute;
    display: block;

    bottom: 0;
    left: 10px;
    right: 10px;

    border-bottom: 2px solid transparent;
  }

  > .title,
  > .count {
    margin: 0;

    text-align: left;
    color: #8c8786;
  }

  > .title {
    font-size: 16px;
  }

  > .count {
    font-size: 11px;
  }
}

.tab.active,
.tab:hover {
  text-decoration: none;
  border-bottom: 0;

  &::after {
    border-bottom-color: #e27024;
  }

  > .title {
    color: black;
  }

  > .count {
    color: #e27024;
    font-weight: bold;
  }
}
</style>
